/**
 * @author Ivan Toth.
 */
var bindLogs = { vm: '=' };
var DetailTableLogController = (function () {
    function DetailTableLogController(topic, Dialog, settings, $scope, socket) {
        this.topic = topic;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$scope = $scope;
        this.socket = socket;
        return;
    }
    ;
    /**
     * Contains 2 switches and 1 show dialog section. 1st switch decides what should be the data and name of the dialog based on whichLogs
     * 2nd switch decides the column headers and what is the layout of the field values
     * @param event - in html I'm passing the $event.
     * @param whichLogs - string -  identifies which logs should be shown
     */
    DetailTableLogController.prototype.viewLogs = function (event, whichLogs) {
        console.log('In the logs service');
        var logsData;
        var dialogName;
        var tableType;
        var columnHeaders;
        var items;
        switch (whichLogs) {
            case 'status':
                logsData = this.topic.topic.status.history;
                dialogName = 'History Log';
                break;
            case 'gpp_valid':
                logsData = this.topic.topic.gpp_history;
                dialogName = 'Opportunity Validation Changes Log';
                break;
            case 'gpp':
                logsData = this.topic.topic.gpp_lastload_history;
                dialogName = 'Opportunity Summary Changes Log';
                break;
            case 'calculation':
                logsData = this.topic.topic.calculation_logs.log;
                dialogName = 'Calculation Changes Log';
                break;
            default:
                return alert('Unkown logs, please add it in the component: ' + whichLogs);
        }
        switch (whichLogs) {
            case 'status':
                tableType = 'status';
                columnHeaders = ['Date & Time', 'Event', 'User', 'Description', 'Cycle Owner'];
                break;
            case 'gpp_valid':
            case 'gpp':
                tableType = 'general';
                columnHeaders = ['Updates', 'Date & Time', 'Source', 'Comment'];
                break;
            case 'calculation':
                tableType = 'calc';
                columnHeaders = ['Date & Time', 'Source', 'Comment'];
                break;
            default:
                break;
        }
        items = {
            dialogName: dialogName, logsData: logsData, tableType: tableType, columnHeaders: columnHeaders,
            dateFormat: this.settings.up.preferences.dateFormat
        };
        this.Dialog.updateValidForm(event, items, 'detail-logs-popup.html').then(function (dResult) {
            return;
        });
    };
    DetailTableLogController.$inject = ['topic', 'Dialog', 'settings', '$scope', 'socket'];
    return DetailTableLogController;
}());
var DetailTableLogComponent = (function () {
    function DetailTableLogComponent() {
        this.bindings = bindLogs;
        this.templateUrl = 'detail-logs-general.html';
        this.controller = DetailTableLogController;
    }
    return DetailTableLogComponent;
}());
angular
    .module('application')
    .component('detailTableLog', new DetailTableLogComponent());

//# sourceMappingURL=detail.table.logs.component.js.map
